import { DispatchProps, OwnProps, StateProps } from './ServiceTypeCreateScreen';
import ServiceTypeCreate from './ServiceTypeCreateScreen';
import { StoreState } from '../../../../../../store/reducers';
import { selectTitleProviders } from '../../../../../../store/selectors/providers-selectors';
import { Dispatch } from 'redux';
import { QueryParams } from '../../../../../../types/grid';
import { getProviders, getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { connect } from 'react-redux';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.serviceTypes.inProgress,
        providers: selectTitleProviders(state),
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const ServiceTypeCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceTypeCreate);

export default ServiceTypeCreateScreen;
